export default "__VITE_ASSET__CIQiPaGP__"